import { render, staticRenderFns } from "./BannerSmallCreate.vue?vue&type=template&id=1d4122ec&"
import script from "./BannerSmallCreate.vue?vue&type=script&lang=js&"
export * from "./BannerSmallCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports